/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

//回收站
const recycled = require('appComp/page/recycled/recycled/recycled');
const recycledtopic = require('appComp/page/recycled/recycled-topic/recycled-topic');
const recycledPost = require('appComp/page/recycled/recycled-post/recycled-post');
const recycledComment = require('appComp/page/recycled/recycled-comment/recycled-comment');
const chargerComment = require('appComp/page/recycled/charger-comment/charger-comment');
const recycledInfo = require('appComp/page/recycled/recycled-info/recycled-info');

module.exports = {
  component: recycled,
  subRoutes: {
    "/recycledtopic": {
    	component: recycledtopic,
      name:"recycletopicd",
      title: "话题回收站"
    },
    "/recycledpost":{
    	component: recycledPost,
    	name:"recycledpost",
      title: "帖子回收站"
    },
    "/recycledcomment":{
      component: recycledComment,
      name:"recycledcomment",
      title: "二级评论回收站"
    },
    "/chargercomment":{
      component:chargerComment,
      name:"chargercomment",
      title:"充电点评论"
    },
    "recycledinfo":{
      component: recycledInfo,
      name:"recycledinfo",
      title:"资讯详情"
    }
  }
}



// WEBPACK FOOTER //
// ./src/appBackend/router/recycled.js